import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  INVOICEPAYMENTTYPE_LIST_ERROR,
  INVOICEPAYMENTTYPE_LIST_LOADING,
  INVOICEPAYMENTTYPE_LIST_RESET,
  INVOICEPAYMENTTYPE_LIST_VIEW,
  INVOICEPAYMENTTYPE_LIST_SUCCESS
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  items: [],
  view: []
};

function error(error) {
  return {type: INVOICEPAYMENTTYPE_LIST_ERROR, error};
}

function loading(loading) {
  return {type: INVOICEPAYMENTTYPE_LIST_LOADING, loading};
}

function success(items) {
  return {type: INVOICEPAYMENTTYPE_LIST_SUCCESS, items};
}

function view(items) {
  return { type: INVOICEPAYMENTTYPE_LIST_VIEW, items};
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
  view: state => state.view
};

const actions = {
    getItems({ commit }, page = '/invoice_payment_types') {
      commit(loading(true));
      commit(error(null));

      return http.fetch(page)
        .then(response => response.json())
        .then(data => {
          commit(loading(false));
          commit(success(data['hydra:member']));
          commit(view(data['hydra:view']));
        })
        .catch(e => {
          commit(loading(false));
          if(security.handleAuthorizationError(e)){
            return;
          }
          commit(error(e.message));
        });
    }
};

const mutations = {
    [INVOICEPAYMENTTYPE_LIST_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [INVOICEPAYMENTTYPE_LIST_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [INVOICEPAYMENTTYPE_LIST_VIEW] (state, payload) {
      state.view = payload.items;
    },
    [INVOICEPAYMENTTYPE_LIST_SUCCESS] (state, payload) {
      state.items = payload.items;
    },
    [INVOICEPAYMENTTYPE_LIST_RESET] (state) {
      state.items = [];
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoicepaymenttype/list.js